export default __webpack_public_path__ + "static/media/me.9667f485.jpg";